import Icon from "components/Elements/Icon/Icon";
import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup";
import { ReuploadAction } from "components/Reusable/FilesActionGroup/ReuploadAction";
import { useContent } from "contexts/contentContext/contentContext";
import { useMail } from "contexts/mailContext/mailContext";
import useMediaQueries from "hooks/useMediaQueries";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper";
import useUploadComplete from "../hooks/useUploadComplete";
import { type Dispatch, forwardRef, type SetStateAction } from "react";

interface UploadedFilesInfoI {
  showFiles: boolean;
  setShowFiles: Dispatch<SetStateAction<boolean>>;
  recipientsList: string[];
  handleShareClick: () => void;
}

const UploadedFilesInfo = forwardRef<HTMLDivElement, UploadedFilesInfoI>(
  ({ showFiles, setShowFiles, recipientsList, handleShareClick }, ref) => {
    const { getTextByKey } = useContent();
    const { getMailMetaData, getMailId } = useMail();
    const { mobileCondition } = useMediaQueries();
    const { isSizeValidation } = useUploadComplete();

    const size = bytesToDisplayHelper(getMailMetaData().TotalSize);

    return (
      <div className="upload-complete-sidebar-body-row uploaded-files-row">
        <div className="info">
          <div className="info-title">
            {getTextByKey("upload-complete-number-of-files")}:
          </div>
          <div className="info-value">
            {getMailMetaData().filesCount} ({size.size + size.type})
            {isSizeValidation
              ? ` / ${getMailMetaData().expectedFilesCount}`
              : null}
          </div>
        </div>

        {isSizeValidation ? (
          <div
            className="action"
            onClick={() => {
              setShowFiles((prev) => !prev);
            }}
            ref={ref}
          >
            <Icon name="warning" blue />
            {getTextByKey("upload-complete-show")}
            <CustomPopup showState={showFiles} topPosition={30}>
              <div className="full-recipents-list">
                <div className="right-side">
                  {getMailMetaData().errorFilesList?.map((item) => {
                    const size = bytesToDisplayHelper(item.size);
                    return (
                      <div className="mail-adress" key={item.name}>
                        {item.name} ({size.size + size.type})
                      </div>
                    );
                  })}
                </div>
              </div>
            </CustomPopup>
          </div>
        ) : mobileCondition && !recipientsList[0] ? (
          <div className="action" onClick={handleShareClick}>
            <Icon name="share-solid" blue />
            {getTextByKey("sidebar-share-header")}
          </div>
        ) : null}
        <ReuploadAction mailId={getMailId()} />
      </div>
    );
  }
);

UploadedFilesInfo.displayName = "UploadedFilesInfo";

export default UploadedFilesInfo;
